export default {"src":"/_next/static/media/rounded-spacy.3f5de300.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};